/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useContext, useRef, useCallback } from "react";
import { purchaseService } from "../../services/purchase.service";
import { Dropdown } from "react-bootstrap";
import LogicContext from "../../Context/LogicContext";
import { GetPurchaseReceiveListData, SetPurchaseReceiveListData } from '../../store/purchaseReceiveAtom';
// import CurrencyFormat from 'react-currency-format';
import Tooltip from "@mui/material/Tooltip";
import RestartAlt from "@mui/icons-material/RestartAlt";
import { useState } from "react";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { useLocation, useNavigate } from "react-router-dom";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { useForm } from "react-hook-form";
import moment from "moment";
import { toLowercaseKeys } from "../../helpers/toLowerCaseKeys";
import StatusBadge from "../../generals/StatusBadge";




const columns = [
  {
    title: 'Id',
    key: 'purchase_receive_ref_no',
    dataIndex: 'purchase_receive_ref_no',
    sorter: (a, b) => (a?.purchase_receive_ref_no ?? '') - (b?.purchase_receive_ref_no ?? '')

    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },
  {
    title: 'Order No',
    key: 'purchase_order_number',
    dataIndex: 'purchase_order_number',
    className: "text-primary",
    sorter: (a, b) => (a?.purchase_order_number ?? '').localeCompare(b?.purchase_order_number ?? '')
    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },
  {
    title: 'Created Date',
    dataIndex: 'created_date_string',
    sorter: (a, b) => (a?.created_date_string ?? '').localeCompare(b?.created_date_string ?? '')

    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },
  {
    title: 'Vendor Name',
    dataIndex: 'vendor_name',
    sorter: (a, b) => (a?.vendor_name ?? '').localeCompare(b?.vendor_name ?? '')

    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },

  {
    title: 'Customer Name',
    dataIndex: 'created_user_full_name',
    sorter: (a, b) => (a?.created_user_full_name ?? '').localeCompare(b?.created_user_full_name ?? '')

    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },



  {
    title: 'Status',
    dataIndex: 'purchase_receive_status_name',
    sorter: (a, b) => (a?.purchase_receive_status_name ?? '').localeCompare(b?.purchase_receive_status_name ?? ''),
    render: (value, row) => (
      <StatusBadge
        statusId={row?.purchase_receive_status_id ?? row?.Purchase_Receive_Status_Id}
        statusName={value}
      />
    ),
  },



];






function PurchaseReceivePage() {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    var url = pathname.split('/')
    const currModuleId = url[1];
    const currModuleName = url[2];
    const currUserMenu = url[3];
    const logicContext = useContext(LogicContext);
    const setPurchaseData = SetPurchaseReceiveListData();
    const getPurchaseListData = GetPurchaseReceiveListData();
    const myPromiseModal = createModal(GeneralModal);
        const [searchText, setSearchText] = useState("");
    const [tableData, setTableData] = useState([]);
    const [itemSelected, setItemSelected] = useState([]);
      const { register, setValue, getValues, handleSubmit, reset, formState: { errors } } = useForm();
    
    const mountRef = useRef(false);



    useEffect(() => {
        document.title = 'Purchase Receives';
        if (getPurchaseListData['Purchase_Receive_Info']?.length > 0) {
            setTableData(getPurchaseListData['Purchase_Receive_Info']);
        }

    }, [getPurchaseListData])



    const getPurchaseReceiveListApi = async () => {
        purchaseService.getPurchaseReceiveList().then(response => {
            if (response?.data !== undefined) {
                setPurchaseData(response.data);
            }
        });
    }


// purchaseReceiveByDate;
    function selectedTableItems(itemList) {
        setItemSelected(itemList);
    }

      const searchByDate = useCallback(async () => {
        const formData = getValues();
        try {
          const response = await purchaseService.purchaseReceiveByDate(formData);
          const serverData = toLowercaseKeys(response?.data);
          if (serverData?.length) {
            setTableData(serverData);
          } else {
            // showToast("No result found", "");
            setTableData([]);
          }
        } catch (err) {
        }
      }, []);



    function addNewInvoice() {
        navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`)
    }




    async function bulkActions(action) {
        await myPromiseModal({
            title: 'confirm your action!',
            body: `Do you want to ${action.Action_Name} ?`,showInput:false, placeHolder:''
        }).then((result) => {

            if (result.decision === true) {
                let temp = '';
                const option = action.Procedure_Option;
                itemSelected.map(item => {
                    temp += `<a> <refno> ${item.Bill_Ref_No} </refno> </a>`
                });

                let xml_string_refno = `<root> ${temp} </root>`;
                purchaseService.setBillBulkAction({ xml_string_refno, option }).then(res => {
                    if (res?.data !== undefined) {
                        const { message_text } = res.data[0];
                        logicContext.showToast(message_text, 'success');
                        return getPurchaseReceiveListApi();
                    }
                }).catch((err) => {
                    logicContext.showToast('Error', 'error');
                });
            }

        });
    }

    function handleRowClick(sel){
        const id = sel['purchase_receive_ref_no'];
        navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`)
      }
      

        const handleSearch = text => {
          setSearchText(text);

          if (text.trim() === '') {
            setTableData(getPurchaseListData['Purchase_Receive_Info'] || []);
            return;
          }

          const searchTerm = text.toLowerCase();
          const filtered = (getPurchaseListData['Purchase_Receive_Info'] || []).filter(vendor =>
            Object.values(vendor).some(value => value?.toString().toLowerCase().includes(searchTerm))
          );
          setTableData(filtered);
        };



  const onClearInput = () => {
    setSearchText('');
    setTableData(getPurchaseListData['Purchase_Receive_Info'] || []);
  };




    return (
      <>
        <section>
          <div className="mt-6 md:flex items-end justify-between space-y-3 md:space-y-0">
            <div className="flex items-center space-x-2">
              <div className="flex items-center px-2 mt-1">
                {itemSelected.length > 0 ? (
                  <Dropdown>
                    <Dropdown.Toggle
                      style={{
                        backgroundColor: '#E5E5E5',
                        border: 'none',
                        color: '#45444B',
                        fontSize: '12px',
                        height: '45px',
                      }}
                      id="dropdown-basic"
                    >
                      Bulk Actions
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {getPurchaseListData['Purchase_Receive_Info']?.map((action, i) => (
                        <Dropdown.Item key={i} onClick={() => bulkActions(action)}>
                          {action.Action_Name}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                ) : (
                  <span></span>
                )}

                <Tooltip title="Reload">
                  <RestartAlt
                    className="ml-2 mt-1 cursor-pointer"
                    onClick={() => getPurchaseReceiveListApi()}
                    color="primary"
                    fontSize="large"
                  />
                </Tooltip>
              </div>
          
            </div>

            <div className="flex flex-row items-end space-x-2">
              <div>
                <span className="ml-1 text-sm">From Date:</span>
                <input
                  defaultValue={moment(Date.now()).format('YYYY-MM-DD')}
                  {...register('from_date')}
                  className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full outline-none border-transparent focus:border-transparent focus:ring-0"
                  type="date"
                />
              </div>
              <div>
                <span className="ml-1 text-sm">To Date:</span>
                <input
                  {...register('to_date')}
                  defaultValue={moment(Date.now()).format('YYYY-MM-DD')}
                  className="bg-white ring-1 ring-gray-200 w-full pl-3 rounded max-h-full outline-none border-transparent focus:border-transparent focus:ring-0"
                  type="date"
                />
              </div>
              <div>
                <button onClick={searchByDate} type="button" className="text-sm text-white px-3 bg-blue-500 rounded py-2.5">
                  Search
                </button>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <Tooltip title="Add New">
                {/* <button
                  onClick={addNewInvoice}
                  className="ml-2 h-fit w-fit px-3 py-2.5 bg-gray-200 border-[1.5px] border-gray-300 rounded-md text-white focus:outline-none font-medium hover:bg-gray-100 active:bg-gray-200 transition-all duration-200"
                >
                  <FaPlus className="h-[16px] w-[16px] text-gray-600" />
                </button> */}
              </Tooltip>
            </div>
          </div>

          {/* Start of search */}
          <div className="flex justify-center mt-4">
            <div className="flex flex-col w-full md:w-1/3">
              <input
                type="text"
                placeholder="Search in table"
                value={searchText}
                onKeyDown={e => {
                  if (e.key === 'Backspace') {
                    onClearInput();
                  }
                }}
                onChange={e => handleSearch(e.target.value)}
                className="bg-white ring-1 ring-gray-200 w-full pl-3 py-2 rounded outline-none focus:ring-blue-300"
              />
            </div>
          </div>
          {/* End of search */}

          <section className="mt-2 mb-2">
            <GeneralCustomTable
              tableHeadList={columns}
              tableDataList={tableData}
              allowCheckBox={true} // show checkBox for each row
              setSelectedRows={selectedTableItems}
              rowKey={record => record.purchase_receive_ref_no} // custom key
              handleRowClick={handleRowClick}
            />
          </section>
        </section>
      </>
    );
}

export default PurchaseReceivePage;
